import styled from 'styled-components';

import Container from '../Container';
import Content from '../Content';



export const ComposhFlatListContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;


export const ComposhFlatListStyle = styled(Content)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ComposhFlatListContent = styled.div`
  display: flex;
  flex-direction: column;
`;
